// extracted by mini-css-extract-plugin
module.exports = {"message":"styles_message__3xY22","indicator":"styles_indicator__3WA7y"};